import { useState } from "react";
import { UserCog, X } from "lucide-react";

export const TechFormModal = ({ tech, onClose, onSubmit }) => {
  const isEditMode = !!tech;
  
  const [formData, setFormData] = useState(
    isEditMode 
      ? { ...tech }
      : {
          firstName: '',
          lastName: '',
          company: '',
          email: '',
          mobile: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          area: ''
        }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="modal-overlay" data-testid="tech-modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2 className="modal-title">
              <UserCog size={20} />
              {isEditMode ? 'Edit Field Tech' : 'Add Field Tech'}
            </h2>
          </div>
          <button className="modal-close-btn" onClick={onClose} data-testid="modal-close-btn">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="ticket-form">
          <div className="form-section">
            <h3 className="form-section-title">Personal Information</h3>
            <div className="form-row">
              <div className="form-group">
                <label>First Name *</label>
                <input 
                  type="text" 
                  name="firstName" 
                  value={formData.firstName} 
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <label>Last Name *</label>
                <input 
                  type="text" 
                  name="lastName" 
                  value={formData.lastName} 
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Company</label>
                <input 
                  type="text" 
                  name="company" 
                  value={formData.company} 
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label>Area</label>
                <input 
                  type="text" 
                  name="area" 
                  value={formData.area} 
                  onChange={handleChange}
                  className="form-input"
                  placeholder="e.g., North Alabama"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="form-section-title">Contact Information</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Email *</label>
                <input 
                  type="email" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <label>Mobile #</label>
                <input 
                  type="tel" 
                  name="mobile" 
                  value={formData.mobile} 
                  onChange={handleChange}
                  className="form-input"
                  placeholder="(555) 123-4567"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="form-section-title">Address</h3>
            <div className="form-row">
              <div className="form-group full-width">
                <label>Street Address</label>
                <input 
                  type="text" 
                  name="address" 
                  value={formData.address} 
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City</label>
                <input 
                  type="text" 
                  name="city" 
                  value={formData.city} 
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
              <div className="form-group" style={{ maxWidth: '100px' }}>
                <label>State</label>
                <input 
                  type="text" 
                  name="state" 
                  value={formData.state} 
                  onChange={handleChange}
                  className="form-input"
                  maxLength={2}
                  placeholder="AL"
                />
              </div>
              <div className="form-group" style={{ maxWidth: '120px' }}>
                <label>ZIP</label>
                <input 
                  type="text" 
                  name="zip" 
                  value={formData.zip} 
                  onChange={handleChange}
                  className="form-input"
                  maxLength={10}
                />
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit" data-testid="submit-tech-btn">
              <UserCog size={16} />
              {isEditMode ? 'Save Changes' : 'Add Tech'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
